"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TablesDisplayGrid = exports.tablesWithCrassCellFormatters = exports.columnsForVizPortal = exports.columns = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var Localize_1 = require("@tableau/widgets/lib/gen-src/Localize");
var React = require("react");
var Localize_2 = require("../../../gen-src/Localize");
var globalTypes_1 = require("../../../gen-src/queries/globalTypes");
var DatabaseNameCell_1 = require("../datagrid/cellFormatters/DatabaseNameCell");
var ObfuscatedCellFormatter_1 = require("../datagrid/cellFormatters/ObfuscatedCellFormatter");
var ProjectLocationCellFormatter_1 = require("../datagrid/cellFormatters/ProjectLocationCellFormatter");
var UserNameCell_1 = require("../datagrid/cellFormatters/UserNameCell");
var makeColumnFactoryParams_1 = require("../sorting/makeColumnFactoryParams");
var LocationTypes_1 = require("./types/LocationTypes");
var shouldBeObfuscated = function (_a) {
    var name = _a.name;
    return name === null;
};
function iconColumn() {
    return React.createElement(data_catalog_shared_1.TableMediumIcon, { isCertified: false });
}
var rowDataFunctions = {
    getAssetUrlFromRowData: function (urls, r) {
        return urls.catalogTableUrl(r.id);
    },
    getNameFromRowData: function (r) { return (r.name ? r.name : ''); },
    getTypeNameFromRowData: function () { return 'DatabaseTable'; },
    getDataQualityCertificationFromRowData: function (r) {
        return r.__typename === 'DatabaseTable' ? r.dataQualityCertifications : [];
    },
};
exports.columns = [
    function (sortParams) { return ({
        name: 'type',
        dataKey: globalTypes_1.DatabaseTableOrderField.IS_CERTIFIED,
        headerText: Localize_2.Messages.GridHeaderType(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: data_catalog_shared_1.createIconCellFormatter(function () { return iconColumn(); }, function (rowData) {
            return rowData.__typename === 'DatabaseTable' && rowData.isCertified
                ? ''
                : Localize_2.Messages.Table();
        }),
        resizable: false,
        sortable: true,
    }); },
    function () { return ({
        name: 'certification',
        dataKey: '',
        headerText: '',
        headerTooltip: Localize_2.Messages.Certification(),
        headerFormatter: data_catalog_shared_1.DataQualityIconHeaderCertificationFormatterFactory,
        cellFormatter: data_catalog_shared_1.createDataQualityCellFormatter({
            getWarningsFromRowData: function (r) {
                return r.__typename === 'DatabaseTable' ? r.dataQualityWarnings : [];
            },
            disableIconOnlyTabIndex: true,
            isCertification: true,
            rowDataFunctions: rowDataFunctions,
        }),
        sortable: false,
        resizable: false,
    }); },
    function () { return ({
        name: 'warning',
        dataKey: '',
        headerText: '',
        headerTooltip: Localize_2.Messages.DataQualityWarningTitle(),
        headerFormatter: data_catalog_shared_1.DataQualityIconHeaderFormatterFactory,
        cellFormatter: data_catalog_shared_1.createDataQualityCellFormatter({
            getWarningsFromRowData: function (r) {
                if (r.__typename !== 'DatabaseTable' || r.id === '') {
                    return [];
                }
                else {
                    return r.dataQualityWarnings;
                }
            },
            disableIconOnlyTabIndex: true,
            isCertification: false,
            rowDataFunctions: rowDataFunctions,
            getChildWarningsFromRowData: getChildWarningsFromRowDataImpl,
        }),
        sortable: false,
        resizable: false,
    }); },
    function (params) { return ({
        name: 'name',
        dataKey: globalTypes_1.DatabaseTableOrderField.NAME,
        headerText: Localize_2.Messages.GridHeaderName(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(params),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedLinkCellFormatter(shouldBeObfuscated, function (_a) {
            var name = _a.name;
            return name;
        }, function (urls, _a) {
            var id = _a.id;
            return urls.catalogTablePath(id);
        }, undefined, // noPadding
        true // disableTabIndex
        ),
        growToFit: true,
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'virtualConnections',
        dataKey: globalTypes_1.DatabaseTableOrderField.DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT,
        headerText: Localize_2.Messages.GridHeaderVirtualConnection(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: data_catalog_shared_1.createTextCellFormatter(function (_a) {
            var downstreamVirtualConnectionsConnection = _a.downstreamVirtualConnectionsConnection;
            return downstreamVirtualConnectionsConnection
                ? Localize_1.Formatters.formatCount(downstreamVirtualConnectionsConnection.totalCount)
                : null;
        }),
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'workbooks',
        dataKey: globalTypes_1.DatabaseTableOrderField.DOWNSTREAM_WORKBOOKS_COUNT,
        headerText: Localize_2.Messages.GridHeaderWorkbooks(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: data_catalog_shared_1.createTextCellFormatter(function (_a) {
            var downstreamWorkbooksConnection = _a.downstreamWorkbooksConnection;
            return downstreamWorkbooksConnection
                ? Localize_1.Formatters.formatCount(downstreamWorkbooksConnection.totalCount)
                : null;
        }),
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'datasources',
        dataKey: globalTypes_1.DatabaseTableOrderField.DOWNSTREAM_DATASOURCES_COUNT,
        headerText: Localize_2.Messages.GridHeaderDatasources(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: data_catalog_shared_1.createTextCellFormatter(function (_a) {
            var downstreamDatasourcesConnection = _a.downstreamDatasourcesConnection;
            return downstreamDatasourcesConnection
                ? Localize_1.Formatters.formatCount(downstreamDatasourcesConnection.totalCount)
                : null;
        }),
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'database',
        dataKey: '',
        headerText: Localize_2.Messages.GridHeaderDatabaseNamePath(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedTextWithIconCellFormatter(shouldBeObfuscated, DatabaseNameCell_1.getDatabaseDisplayString, DatabaseNameCell_1.tableDatabaseGroupIcon, DatabaseNameCell_1.tableDatabaseCellTitle, undefined, // placeholder
        function (rowData) { return rowData.id === ''; }),
        resizable: true,
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'columns',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: Localize_2.Messages.GridHeaderColumns(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedNamesWithCountCellFormatter(shouldBeObfuscated, function (_a) {
            var columnsConnection = _a.columnsConnection;
            return columnsConnection
                ? columnsConnection.nodes.map(function (column) { return column.name || ''; })
                : [];
        }, function (_a) {
            var columnsConnection = _a.columnsConnection;
            return columnsConnection ? columnsConnection.totalCount : 0;
        }, undefined, // maxShown
        undefined, // ObfuscatedComponent
        function (rowData) { return rowData.id === ''; }),
        resizable: true,
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'projectName',
        dataKey: globalTypes_1.DatabaseTableOrderField.PROJECT_NAME,
        headerText: Localize_2.Messages.GridHeaderLocation(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedLocationLinkOrTextCellFormatter(shouldBeObfuscated, function (rowData) { return getProjectName(rowData.__typename, rowData.projectName, rowData.isEmbedded); }, function (urls, rowData) { return getProjectLink(urls, rowData.projectVizportalUrlId); }, false),
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'contact',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: Localize_2.Messages.GridHeaderContact(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: UserNameCell_1.createUserNameLinkCellFormatter(function (rowData) {
            return rowData.__typename === 'DatabaseTable' ? rowData.contact : null;
        }, true, function (rowData) { return rowData.id === ''; }),
        resizable: true,
        sortable: false,
    }); },
];
/**
 * @deprecated These cell formatters are already in use in the columns above. These defs below will be removed once we have
 * the columns used properly in vpc.
 */
var cellFormattersForCrass = {
    dataQualityWarning: {
        type: 'table',
        cellFormatter: data_catalog_shared_1.createDataQualityCellFormatter({
            getWarningsFromRowData: function (r) {
                if (r.__typename !== 'DatabaseTable' || r.id === '') {
                    return [];
                }
                else {
                    return r.dataQualityWarnings;
                }
            },
            disableIconOnlyTabIndex: true,
            isCertification: false,
            rowDataFunctions: rowDataFunctions,
        }),
    },
    typeForCrass: {
        type: 'table',
        cellFormatter: data_catalog_shared_1.createIconCellFormatter(function () { return iconColumn(); }, function (rowData) {
            return rowData.__typename === 'DatabaseTable' && rowData.isCertified
                ? ''
                : Localize_2.Messages.Table();
        }),
    },
    name: {
        type: 'table',
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedLinkCellFormatter(shouldBeObfuscated, function (_a) {
            var name = _a.name;
            return name;
        }, function (urls, _a) {
            var id = _a.id;
            return urls.catalogTablePath(id);
        }, undefined, // noPadding
        true, // disableTabIndex
        undefined, // ObfuscatedComponent
        function (rowData) { return rowData.id === ''; }),
    },
    downstreamWorkbookCount: {
        type: 'table',
        cellFormatter: data_catalog_shared_1.createTextCellFormatter(function (_a) {
            var downstreamWorkbooksConnection = _a.downstreamWorkbooksConnection;
            return downstreamWorkbooksConnection
                ? Localize_1.Formatters.formatCount(downstreamWorkbooksConnection.totalCount)
                : null;
        }),
    },
    downstreamDataSourcesCount: {
        type: 'table',
        cellFormatter: data_catalog_shared_1.createTextCellFormatter(function (_a) {
            var downstreamDatasourcesConnection = _a.downstreamDatasourcesConnection;
            return downstreamDatasourcesConnection
                ? Localize_1.Formatters.formatCount(downstreamDatasourcesConnection.totalCount)
                : null;
        }),
    },
    database: {
        type: 'table',
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedTextWithIconCellFormatter(shouldBeObfuscated, DatabaseNameCell_1.getDatabaseDisplayString, DatabaseNameCell_1.tableDatabaseGroupIcon, DatabaseNameCell_1.tableDatabaseCellTitle, undefined, // placeholder
        function (rowData) { return rowData.id === ''; }),
    },
    columns: {
        type: 'table',
        cellFormatter: ObfuscatedCellFormatter_1.createObfuscatedNamesWithCountCellFormatter(shouldBeObfuscated, function (_a) {
            var columnsConnection = _a.columnsConnection;
            return columnsConnection
                ? columnsConnection.nodes.map(function (column) { return column.name || ''; })
                : [];
        }, function (_a) {
            var columnsConnection = _a.columnsConnection;
            return columnsConnection ? columnsConnection.totalCount : 0;
        }, undefined, // maxShown
        undefined, // ObfuscatedComponent
        function (rowData) { return rowData.id === ''; }),
    },
    contact: {
        type: 'table',
        cellFormatter: UserNameCell_1.createUserNameLinkCellFormatter(function (rowData) {
            return rowData.__typename === 'DatabaseTable' ? rowData.contact : null;
        }, true, function (rowData) { return rowData.id === ''; }),
    },
    tableProjectLocation: {
        type: 'table',
        cellFormatter: ProjectLocationCellFormatter_1.createProjectLocationLinkCellFormatter(function (rowData) { return rowData.containerId === undefined ? null : rowData.containerId; }, function (rowData) { return rowData.containerName === undefined ? null : rowData.containerName; }, true, function (rowData) { return rowData.isEmbedded === undefined ? null : rowData.isEmbedded; }, function (rowData) { return rowData.id === ''; }),
    },
};
exports.columnsForVizPortal = data_catalog_shared_1.mapDC3ColumnFactoriesToVizPortalColumnFactories(exports.columns, makeColumnFactoryParams_1.makeDC3ColumnFactoryParamsFromVizPortalParams);
exports.tablesWithCrassCellFormatters = cellFormattersForCrass;
function TablesDisplayGrid(props) {
    var publishedConnectionsLineageEnabled = React.useContext(data_catalog_shared_1.FeatureFlagsContext).publishedConnectionsLineageEnabled;
    var cols = exports.columns
        .map(function (columnFactory) { return columnFactory(props); })
        .filter(function (column) {
        if (column.name === 'virtualConnections' && !publishedConnectionsLineageEnabled) {
            return false;
        }
        return true;
    });
    return (React.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, emptyGridMessage: props.emptyGridMessage, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.TablesDisplayGrid = TablesDisplayGrid;
function getChildWarningsFromRowDataImpl(_a) {
    var columnsConnectionWithWarnings = _a.columnsConnectionWithWarnings;
    var result = [];
    if (!columnsConnectionWithWarnings) {
        return result;
    }
    columnsConnectionWithWarnings.nodes.forEach(function (n) {
        result = result.concat(n.dataQualityWarnings);
    });
    return result;
}
function getProjectName(__typename, projectName, isEmbedded) {
    if (__typename === 'DatabaseTable') {
        if (projectName !== null && projectName !== undefined) {
            if (isEmbedded) {
                return LocationTypes_1.LocationTypes.NotApplicable;
            }
            else if (projectName.length === 0) {
                return LocationTypes_1.LocationTypes.None;
            }
            else {
                return projectName;
            }
        }
        else {
            return LocationTypes_1.LocationTypes.None;
        }
    }
    else {
        return null;
    }
}
function getProjectLink(urls, projectVizportalUrlId) {
    if (projectVizportalUrlId !== undefined && projectVizportalUrlId !== null && projectVizportalUrlId.length !== 0) {
        return urls.projectPath(projectVizportalUrlId ? projectVizportalUrlId : '');
    }
    else {
        return null;
    }
}
//# sourceMappingURL=TablesDisplayGrid.js.map